import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { RichText } from 'prismic-reactjs';

import {
  Card,
  Header,
  Body,
  Details,
  Saving,
  Pricing,
  StandardPrice,
  Price,
  Conditions,
  Copy,
  Label,
  Features,
  Feature,
  Footer,
  Disclaimer,
  StyledLink,
  StyledImage,
} from './styles';

// * buttonType {}
// * component {}
// * cta {}
// * ctaText {}
// * currency {}
// * disclaimer {}
// * flagValue {string} The value to appear in the saving icon
// * iconGroup {}
// * image {}
// * label {RichText}
// * legal {RichText}
// * originalPrice {string} The original price of the membership before discount
// * price {string} The active price set
// * productDesription {RichText} Conditions required to recieve that price
// * savings {string} the value amount you are saving
// * title {RichText} The title of each card price

const PricingCard = ({ data }) => {
  if (!data) return null;
  const {
    cardGroup,
    buttonType,
    component,
    cta,
    ctaText,
    currency,
    flagValue,
    iconGroup,
    originalPrice,
    price,
    imagePriceCard,
    savings,
    titleHtml,
    disclaimer,
    label,
    legal,
    productDescription,
    queryStringCTA,
    ariaLabelCTA,
    colourOverrideBackground,
    flagValueColourOverride,
    titleOutlineColourOverride,
  } = data;

  return (
    <Card
      className={[component, flagValue && 'with-flag']}
      flagValue={flagValue}
      cardGroup={cardGroup}
      flagValueColourOverride={flagValueColourOverride}
      colourOverrideBackground={colourOverrideBackground}
      titleOutlineColourOverride={titleOutlineColourOverride}
    >
      <Header titleOutlineColourOverride={titleOutlineColourOverride}>
        {ReactHtmlParser(titleHtml)}
      </Header>
      <Body>
        <Details>
          {savings && <Saving>{savings}</Saving>}
          <Pricing>
            <StandardPrice>{originalPrice}</StandardPrice>
            {price && (
              <Price className={price}>
                {price !== 'Free' && <sup>$</sup>}
                {price}
                <span>{currency}</span>
              </Price>
            )}
          </Pricing>
          {productDescription.length > 0 && (
            <Conditions>{RichText.asText(productDescription)}</Conditions>
          )}
        </Details>
        <Copy>
          {imagePriceCard && (
            <StyledImage src={imagePriceCard.url} alt={imagePriceCard.altTag} />
          )}
          {label && <Label>{RichText.asText(label)}</Label>}
          <Features className="no-bullets">
            {iconGroup.map(({ imageSharp, textHtml }, index) => {
              return (
                <Feature
                  image={imageSharp ? imageSharp.publicURL : null}
                  key={`pricing-card-icons-${index.toString()}`}
                >
                  {ReactHtmlParser(textHtml)}
                </Feature>
              );
            })}
          </Features>
        </Copy>
        <Footer>
          {disclaimer.length > 0 && (
            <Disclaimer>{RichText.asText(disclaimer)}</Disclaimer>
          )}
          {cta && ctaText && (
            <StyledLink
              to={`${cta.url}/`}
              className={buttonType}
              queryString={queryStringCTA}
              ariaLabel={ariaLabelCTA}
            >
              {ctaText}
            </StyledLink>
          )}
          {legal.length > 0 && (
            <Conditions className="small">{RichText.asText(legal)}</Conditions>
          )}
        </Footer>
      </Body>
    </Card>
  );
};

PricingCard.propTypes = {
  data: PropTypes.shape().isRequired,
};

PricingCard.defaultProps = {};

export default PricingCard;
